import type { FaireProductEntity } from "../../entity_types/product";

export const p_h2psktut6k: FaireProductEntity = {
  token: "p_h2psktut6k",
  type: "product",
  name: "Four-Prong Moissanite Stud Earrings in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/f86fdfb83928e418ee4e2f6ba5189f99ee00f421b16be21408d07750c44c7a2a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/939696f3e2b8e41aa73f4efdeedb93da8f47292175922413d6156719649ee495.jpeg",
    "https://cdn.faire.com/fastly/2e18dcaeb2a5dcded87ff46276d66d64b7d501d81a200ac1e39c534a064ff050.png",
    "https://cdn.faire.com/fastly/0d33e5b19349a24a47d30b9415cb16281312946f4eae3bb77a3463fb74dd8168.jpeg",
    "https://cdn.faire.com/fastly/09da743d8bbefd65441fa00a10eb55dce6c64c703eeb7748a4007f243e875afd.png",
    "https://cdn.faire.com/fastly/d6e6e9607daf035648fa177251cff2ad833d9526815f7041421a8b95b9af3c8c.jpeg",
  ],
  priceDollars: 19.36,
  description:
    "Description & Details\n\nWhere diamonds symbolize tradition and stability, moissanite is a metaphor for youthfulness, effervescence and the journey of our endeavors.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 950 Platinum (Pt 950) Plating\n• Dimensions: 0.4 - 6.0 ct, Color D, VVS1 Moissanite\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 38.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:12.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
